import React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from '@insurancemenu/imenu-components-lib';
import { ChevronLeft, ChevronRight } from '@insurancemenu/imenu-components-lib/dist/icons';
import { useRFQConfigurePlanAttributesStore } from 'store/pages/rfq/rfq-template/configure-plan-attribute/pageStore';
import {
  BACK_TO_LIST_BTN_TEST_ID,
  SAVE_AND_RETURN_TO_LIST_BTN_TEST_ID,
  SAVE_AND_ADD_NEW_ATTR_BTN_TEST_ID,
} from '../../constants';
import { createStyles } from './styles';

export interface FormFooterProps {
  isFormValid: boolean;
  returnBack: () => void;
  updateData: () => void;
}

const CreateAttributeFormFooter = observer(({ isFormValid, returnBack, updateData }: FormFooterProps): JSX.Element => {
  const classes = createStyles();
  // Mobx store
  const { isLoading, saveCustomAnswers, resetDynamicForm } = useRFQConfigurePlanAttributesStore();

  const saveAndReturnToList = async (): Promise<void> => {
    await saveCustomAnswers();
    returnBack();
  };

  const saveAndCreateNewAttribute = async (): Promise<void> => {
    await saveCustomAnswers();
    resetDynamicForm();
    updateData();
  };

  return (
    <footer className={classes.footer}>
      <Button
        type="outlined"
        size="large"
        width="24rem"
        onClick={returnBack}
        leftIconProp={<ChevronLeft />}
        className={classes.actionButton}
        data-test-id={BACK_TO_LIST_BTN_TEST_ID}
      >
        Back to List
      </Button>
      <div className={classes.continueButtonsWrapper}>
        <Button
          size="large"
          width="24rem"
          color="primary"
          type="outlined"
          onClick={saveAndReturnToList}
          disabled={!isFormValid || isLoading}
          className={classes.actionButton}
          leftIconProp={<ChevronLeft />}
          data-test-id={SAVE_AND_RETURN_TO_LIST_BTN_TEST_ID}
        >
          Save & Return to List
        </Button>
        <Button
          size="large"
          width="24rem"
          color="primary"
          onClick={saveAndCreateNewAttribute}
          rightIconProp={<ChevronRight />}
          disabled={!isFormValid || isLoading}
          className={classes.actionButton}
          data-test-id={SAVE_AND_ADD_NEW_ATTR_BTN_TEST_ID}
        >
          Save & Add New
        </Button>
      </div>
    </footer>
  );
});

export default CreateAttributeFormFooter;
